<div style="margin: 12px;">
    <h5 style="text-align: center;">Scope and Introduction</h5>
    <p style="padding-top: 10px;">This End User License Agreement is between you as an End User and the applicable
        Service Provider and grants you the
        rights to access and use the products and services provided by the Service Provider.</p>

    <p style="padding-bottom: 10px;">By placing and order for the products and services covered by this EULA you have
        agreed to abide to the terms and
        conditions specified in this EULA detailed below and set out <a class="link" (click)="goToEULA(operator)">here</a> at
        where you can read, print and save a copy of these terms and conditions. The Service Provider will not save a
        copy for you. </p>
</div>
